import React, { useEffect, useState } from 'react';
import { DashboardApis } from 'hooks/apis/DashboardApis';
import { formatNumber } from 'helpers/numberFormats';
import StatTile from '../../../components/common/StatTile';

const UserSpendTile = () => {
  const [value, setValue] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { getUserInProgressSamples } = DashboardApis();

  useEffect(() => {
    getUserInProgressSamples()
      .then((data) => {
        if (data && !data.errorMessage) {
          setValue(data);
        } else if (data?.errorMessage) {
          setError(data.errorMessage);
        }
      })
      .finally(() => setLoading(false));
  }, [getUserInProgressSamples]);

  return (
    <StatTile
      label="WIP Samples"
      value={value !== null ? formatNumber(value) : '-'}
      loading={loading}
      error={error}
    />
  );
};

export default UserSpendTile;